import { createContext } from 'react'
import { ThemeWithColors, createTheme } from '@trustmary/form-styles'

export const ThemeContext = createContext<ThemeWithColors>(createTheme({}))
